export function buildTemplateProse(validatedData, insightPacket) {
  const d = validatedData;
  const p = insightPacket;

  const daysLeft    = d.sellingDaysRemaining;
  const dailyNeeded = p.forecast.goal.dailyUnitsNeeded;
  const paceWord    = d.paceToGoal >= 100 ? 'ahead of'
                    : d.paceToGoal >= 80  ? 'near'
                    : d.paceToGoal >= 60  ? 'behind'
                    : 'significantly behind';
  const vsGoal      = p.forecast.baseline.vsGoal;
  const vsGoalWord  = vsGoal >= 0 ? `${vsGoal} above` : `${Math.abs(vsGoal)} short of`;

  return {
    executiveSummary: `${d.repName} is ${paceWord} pace — ${d.unitsSold} of ${d.goal} units in ${d.sellingDaysElapsed} selling days.`,

    performanceStory: `Projecting ${p.forecast.baseline.units} units by month-end, ${vsGoalWord} the ${d.goal}-unit goal.`,

    bottleneckNarrative: p.bottleneck.diagnosis,

    forecastNarrative: dailyNeeded
      ? `${dailyNeeded} units/day needed across ${daysLeft} remaining days to hit goal.`
      : `On track to meet the ${d.goal}-unit goal.`,

    coachingNote: p.bottleneck.lever,
  };
}
